<template>
  <div>
    <div class="w-full" v-if="enableEditItem">
      <div class="form-group">
        <div class="mb-1">
            <b-form-group
              :label="$t('product.type')"
              label-for="type">
                <b-form-radio-group
                  id="type"
                  v-model="model.type"
                  name="type"
                  :options="productTypeList"
                  class="required mr-2"
                  v-on:change="onChangeProductType"/>
            </b-form-group>
        </div>
      </div>
    </div>

    <div class="w-full gap-2 justify-center pt-2" v-if="enableEditItem && model.type">
      <vs-divider class="mt-2" position="left">{{ $t('product.available_items') }}</vs-divider>
      <vs-table no-data=" " :data="availableItems" :key="`available-${model.type}`"
        :no-data-text="$t('product.no_available_items')">
        <template slot="thead">
          <vs-th width="5%">{{ $t('ID') }}</vs-th>
          <vs-th width="50%">{{ $t('name') }}</vs-th>
          <vs-th width="35%">{{ $t('product.detail') }}</vs-th>
          <vs-th width="10%">{{ $t('actions') }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr
            :key="`a-${i}`"
            v-for="(tr, i) in data">
            <vs-td :data="data[i].id">
              <label>{{data[i].id}}</label>
            </vs-td>
            <vs-td :data="data[i].name">
              <label>{{data[i].name}}</label>
            </vs-td>
            <vs-td :data="data[i].detail">
              <label>{{data[i].detail}}</label>
            </vs-td>
            <vs-td>
              <b-button
                v-permission="'products.items.create'"
                variant="primary"
                size="sm"
                @click="addItem(data[i])"
                v-tooltip="{
                  content: $t('adicionar'),
                  delay: { show: 500, hide: 100 }
                }">
                  <feather-icon
                    icon="PlusIcon"/>
              </b-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>

    <div class="w-full gap-2 justify-center pt-2">
      <vs-divider class="mt-4" position="left"> {{ $t('product.composition') }}</vs-divider>
      <vs-table no-data=" " :data="productItems" :key="id"
        :no-data-text="$t('msg_none')">
        <template slot="thead">
          <vs-th width="5%">{{ $t('ID') }}</vs-th>
          <vs-th width="25%">{{ $t('product.type') }}</vs-th>
          <vs-th width="50%">{{ $t('name') }}</vs-th>
          <vs-th width="5%">{{ $t('actions') }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr
            :key="i"
            v-for="(tr, i) in data">
            <vs-td :data="data[i].id">
              <label>{{data[i].id}}</label>
            </vs-td>
            <vs-td :data="data[i].type_str">
              <label>{{data[i].type_str}}</label>
            </vs-td>
            <vs-td :data="data[i].name">
              <label>{{data[i].name}}</label>
            </vs-td>
            <vs-td>
              <feather-icon
                v-permission="'products.items.delete'"
                v-if="enableEditItem"
                icon="Trash2Icon"
                class="h-5 w-5 mb-1 mr-1 stroke-current text-danger cursor-pointer"
                @click="confirmDeleteItem(data[i])"/>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>

import standard from '@/services/standard'
import {
  BForm,
  BButton,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BCardText,
  BFormInput,
  BLink,
  BFormRadioGroup,
  BFormCheckbox,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

import { isAdmin } from '@/util/Util'

import ProductService from '@/services/api/ProductService'


export default {
  directives: {

  },
  components: {
    BForm,
    BButton,
    BFormGroup,
    BInputGroup,
    BFormTextarea,
    BCardText,
    BFormInput,
    BFormRadioGroup,
    BLink,
    BFormCheckbox,
    //
    BFormInvalidFeedback,
  },
  props: {
    id: { //ProductId
      default: null,
      type: Number,
    },
    status: { //Product Status
      default: null,
      type: String
    }

  },

  data: () => ({
    service: null,
    productTypeList: [],
    model: {
      type: null,
      model_id: null,
    },
    availableItems: [],
    productItems: [],
    productItemId: null
  }),
  computed: {
    // Composição precisa continuar editável com o produto "Liberado" (RE):
    // é o status que publica o produto, então travar o editor de itens
    // justamente aí prendia quem esqueceu (ou nem sabia) de montar a
    // composição antes de liberar — sem forma de voltar e corrigir.
    enableEditItem(){
      return true
    }
  },
  beforeMount() {
    this.service = ProductService.build(this.$vs)

  },
  mounted() {
    if (this.id) {
      this.loadData(this.id)
      this.loadProductItemTypes()
    }
  },

  methods: {
    requiredClass(whichData) {
      return !this.isEmpty(whichData) ? 'w-full' : 'w-full required'
    },
    loadData(id) {
      this.$vs.loading()

      this.service.getItems(id).then(
        response => {
          this.productItems = response
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    loadProductItemTypes() {
      this.$vs.loading()

      this.service.getProductItemTypes().then(
        response => {
          this.productTypeList = response
        },
        error => {
          this.$vs.loading.close()
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    loadAvailableItems() {
      if (!this.id || !this.model.type) {
        this.availableItems = []
        return
      }

      this.$vs.loading()

      this.service.getAvailableItems(this.id, this.model.type).then(
        response => {
          this.availableItems = response
        },
        error => {
          this.availableItems = []
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },
    addItem(item) {
      this.$vs.loading()

      const modelData = {
        type: this.model.type,
        model_id: item.id
      }

      this.service.addProductItem(this.id, {form : modelData}).then(
        data => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.loadData(this.id)
          this.loadAvailableItems()
        },
        error => {
          this.showErrors(this.$validator, error)
          this.notifyError(
            this.$vs,
            this.$t('messages.error')
          )
        }
      ).finally(
        () => { this.$vs.loading.close() }
      )
    },
    confirmDeleteItem(data) {
      this.productItemId = data.id
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: this.$t('confirmacao'),
        acceptText: this.$t('sim'),
        cancelText: this.$t('nao'),
        text: this.$t('messages.confirm_deletion'),
        accept: this.deleteProductItem,
      })
    },
    deleteProductItem(){
      this.$vs.loading()
      this.service.deleteProductItem(this.id, this.productItemId).then(
        response => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Successo!',
            text: this.$t('messages.success'),
            color: 'success',
            iconPack: 'feather',
            position: 'top-center',
            icon: 'icon-check-circle'
          })
          this.loadData(this.id)
          this.loadAvailableItems()
        },
        error => {this.$vs.loading.close()}
      )
    },
    onChangeProductType(value){
      this.model.type = value
      this.availableItems = []
      this.loadAvailableItems()
    },
    goBack() {
      this.$router.push('/products')
    },
    isAdmin() {
      return isAdmin()
    },
    isEdit() {
      return !_.isNil(this.id)
    }
  }
}
</script>

<style>

</style>
